<template>

  <v-app>
    <core-filter />
    <core-toolbar />

    <core-view />

    <core-drawer />

    <v-content>
      <core-footer />
    </v-content>

    <SnackMsg ref="appSnackRef"></SnackMsg>
    <AppModal ref="appModalRef">
      <v-toolbar slot="modal_title" color="error" class="text-white" md12 lg12 xs12 sm12><label v-text="$t('appModalTitle')"></label></v-toolbar>
      <!--<div slot="modal_body"> {{__getAppModalText()}} </div>-->
    </AppModal>
    <LoginDialog></LoginDialog>
  </v-app>
</template>
<script>

  import LoginDialog from './Security/LoginDialog.vue';
  import { createNamespacedHelpers, mapGetters } from 'vuex';
  const { mapState, mapMutations, mapActions } = createNamespacedHelpers('app');
  import { __tokenName } from './Common/Store/app/utils/vuexutils';

  export default {
    name: 'App',

    computed: {
      ...mapState('app', ['podruznice', 'currentUser']),
      ...mapGetters([])

    },
    methods: {
      ...mapMutations({ SET_CURRENT_USER: 'SET_CURRENT_USER', SET_PODRUZNICE: 'SET_PODRUZNICE' }),
      ...mapActions({ loadPodruznice: 'loadPodruznice' }),
      prikaziModal() {
        this.appModal.dialog = true;
      },

      ucitajPodruznice() {
        var self = this;
        //  });

        //self.loadPodruznice(false); // Ovdje i u App.vue ucitavam, ovisno ima li ne�to ili ne....
        this.$fetchDataPromise('/api/Base/GetPodruznice', null, null, false)
          .then(x => { this.SET_PODRUZNICE({ data: x, force: false }) })
          .catch(x => self.$displayError(self.$t(x)))

      }

    },
    beforeMount() {
      // Ako netko osvje�i stranicu, uzmem �to je u local storage i vratim u store
      this.SET_CURRENT_USER(null);
    },

    mounted() {
      this.$SET_APP_SNACK(this.$refs.appSnackRef);
      this.$SET_APP_MODAL(this.$refs.appModalRef);
      this.ucitajPodruznice();
    },

    data() {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    components: {
      LoginDialog
      //Header, Menu
      //, ExamRegister
    }
  }
</script>
<style lang="scss">
  @import './Common/Components/materialcomponents/styles/index.scss';
  @import './Common/_styles/app.scss';


  #app {
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;*/
  }
</style>



// WEBPACK FOOTER //
// VueSrc/App.vue